module.exports = __webpack_public_path__ + "static/media/fisherman.19f1646a.svg";